<template>

  <tiptap-vuetify
    ref="edt"
    :value="value"
    @input="edt_input"
    min_height="800px"
    min_width="320px"
    :extensions="extensions"
    label="Notes"
    outlined
  >
    <!--    <template #toolbar="{ buttons, commands, isActive }">-->
    <!--      <div>-->
    <!--        <span>Hallo</span>-->
    <!--        <pre>{{ buttons }}</pre>-->
    <!--        <span>Buy</span>-->
    <!--      </div>-->
    <!--    </template>-->
  </tiptap-vuetify>

</template>

<script>
	import {
		TiptapVuetify,
		Heading,
		Bold, Italic, Underline, Strike, HardBreak,
		Code,
		BulletList, OrderedList, ListItem, Link,
		HorizontalRule, History,
		// Paragraph, Blockquote, HardBreak,
	} from 'tiptap-vuetify'

	import {
		VTextField
	} from 'vuetify'


	export default {
		name: "notes-editor",

		components: {
			TiptapVuetify,
			Heading,
			Bold, Italic, Underline, Strike, HardBreak,
			Code,
			BulletList, OrderedList, ListItem, Link, History
		},

		data: function () {
			return {
				extensions: [
					History,
					Bold, Italic, Underline, Strike, HardBreak,
					[Heading, {options: {levels: [1, 2, 3],}}],
					BulletList, OrderedList, ListItem, Link,
					Code,
				],
			}
		},

		props: {
			value: {
				type: String,
				height: {type: String, default: null,},
				width: {type: String, default: null,},
			}
		},

		methods: {

			// -- Handle controls' events --
			edt_input: function (e) {
				this.$emit('input', e)
			}
		}
	}
</script>

<style scoped>

</style>